import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalStyles from './styles/GlobalStyles';
import { AuthProvider } from './context/AuthContext';
import { PrivateRoute } from './components/PrivateRoute';

// Public Pages
import { Home } from './pages/Home';
import { ForgotPassword } from './pages/ForgotPassword';
import { ResetPassword } from './pages/ResetPassword';
import { PublicSchedule } from './pages/PublicSchedule';

// Admin Layout and Pages
import { AdminLayout } from './components/AdminLayout';
import { AdminDashboard } from './pages/admin/Dashboard';
import { AdminMembers } from './pages/admin/Members';
import { AdminClasses } from './pages/admin/Classes';
import { AdminReservations } from './pages/admin/Reservations';
import { AdminCancelledReservations } from './pages/admin/CancelledReservations';
import { AdminClassOccupancy } from './pages/admin/ClassOccupancy';
import { AdminSettings } from './pages/admin/Settings';

// Member Layout and Pages
import { MemberLayout } from './components/MemberLayout';
import { MemberDashboard } from './pages/member/Dashboard';
import { MemberClasses } from './pages/member/Classes';
import { MemberMyReservations } from './pages/member/MyReservations';
import { MemberProfile } from './pages/member/Profile';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <GlobalStyles />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/public-schedule" element={<PublicSchedule />} />

          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute adminOnly>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="members" element={<AdminMembers />} />
            <Route path="classes" element={<AdminClasses />} />
            <Route path="reservations" element={<AdminReservations />} />
            <Route path="cancelled-reservations" element={<AdminCancelledReservations />} />
            <Route path="class-occupancy" element={<AdminClassOccupancy />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Member Routes */}
          <Route
            path="/member"
            element={
              <PrivateRoute memberOnly>
                <MemberLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/member/dashboard" replace />} />
            <Route path="dashboard" element={<MemberDashboard />} />
            <Route path="classes" element={<MemberClasses />} />
            <Route path="my-reservations" element={<MemberMyReservations />} />
            <Route path="profile" element={<MemberProfile />} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
